import React from "react";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import { Autoplay } from "swiper/modules";
// import { FaArrowRight } from "react-icons/fa";

// Importation des logos
import yangoLogo from "../../assets/Yango.png";
import bicLogo from "../../assets/bic.png";
import yassirLogo from "../../assets/Logo_Yassir.png";
import Aldelia from "../../assets/Aldelia.png";
import Exco from "../../assets/exco.png";


const clients = [
  { name: "Bic", logo: bicLogo },
  { name: "Yango", logo: yangoLogo },
  { name: "Aldelia", logo: Aldelia },
  { name: "exco", logo: Exco },
  { name: "Yassir", logo: yassirLogo },
  { name: "Bic", logo: bicLogo },
  { name: "Yango", logo: yangoLogo },
  { name: "Aldelia", logo: Aldelia },
  { name: "exco", logo: Exco },
  { name: "Yassir", logo: yassirLogo },
];

const ClientsCarousel = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col p-10 items-center bg-[--bg-color]">
      <div className="text-center w-full mb-6  rounded-lg p-3  mx-[40px]">
        <h3 className="text-2xl text-[#004c5f] font-bold">{t('clientsCarousel.heading')}</h3>
        <p href="/" className="text-lg font-semibold">
          {t('clientsCarousel.subtitle')}
        </p>
      </div>
      <div className="w-2/3 md:w-2/3">
      <Swiper
        spaceBetween={50}
        loop={true}
        autoplay={{ delay: 1000 }}
        modules={[Autoplay]}
        breakpoints={{
          0: { // Ajouté pour les petits écrans
            slidesPerView: 2, 
          },
          640: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: 4,
          },
          1024: {
            slidesPerView: 5,
          },
        }}
      >
        {clients.map((client, index) => (
        <SwiperSlide key={index}>
            <img
              src={client.logo}
              alt={client.name}
              className="client-logo h-8 grayscale hover:grayscale-0 transition-all duration-500 ease-[cubic-bezier(0.4,0,0.2,1)] hover:scale-105"
            />
          </SwiperSlide>
        ))}
      </Swiper>
      </div>
    </div>
  );
};

export default ClientsCarousel;